export default __webpack_public_path__ + "static/proven-8b47dd988647b6bc3e61a903464f28d6.svg";